<template>
  <div class="n-ring" :style="{ width: addUnit(ringSize), height: addUnit(ringSize) }">
    <div :style="{ ...roundStyle }" :class="animation ? 'infiniteAnimation' : 'animation'" class="n-ring__gradient">
      <template v-if="arc">
        <div
          v-for="(item, index) in pointListStyle"
          :key="index"
          class="n-ring__point"
          :style="{
            transform: item.transform,
          }"
        >
          <div
            :style="{
              width: `${(ringWidth / 1920) * 100}vw`,
              height: `${(ringWidth / 1920) * 100}vw`,
              background: item.color || defColorList[index],
            }"
          />
        </div>
      </template>
    </div>
    <div
      class="n-ring__gap"
      :style="{
        backgroundColor,
        width: `calc(${addUnit(ringSize)} - ${((ringWidth * 2) / 1920) * 100}vw)`,
        height: `calc(${addUnit(ringSize)} - ${((ringWidth * 2) / 1920) * 100}vw)`,
        padding: `${(gapContent / 1080) * 100}vh`,
      }"
    >
      <div class="n-ring__gap__wrapper">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    animation: {
      type: Boolean,
      default: false,
    },
    // 圆环直径
    ringSize: {
      type: String | Number,
      default: '100%',
    },
    // 圆环宽度 单位vh
    ringWidth: {
      type: Number,
      require: true,
    },
    // 圆环间隔角度 单位deg
    gapDeg: {
      type: Number,
      default: 20,
    },
    // 圆环端头是否为弧形
    arc: {
      type: Boolean,
      default: false,
    },
    // 数据列表 color为空时使用默认颜色,data: { value: number; color?: string }[];
    data: {
      type: Array,
      require: true,
    },
    // 圆环和内容之间的间隔
    gapContent: {
      type: Number,
      default: 8,
    },
    // 圆环渐变类型 cut:分割渐变 gradient:渐变
    gradientType: {
      type: String,
      default: 'cut',
    },
    // 圆环内容背景色
    backgroundColor: {
      type: String,
      default: '#062058',
    },
    // 圆环间隔背景色
    gapBackgroundColor: {
      type: String,
      default: '#b7defd17',
    },
  },
  data() {
    return {
      defColorList: ['#ffffff', '#91c375', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'],
      pointListStyle: { color: '', transform: '' },
      roundStyle: { background: '' },
    }
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(val) {
        const list = val.map(item => {
          return {
            value: 100 / val.length,
            color: item.color,
          }
        })
        this.roundStyle.background = this.generateBackground(list)
      },
    },
  },
  methods: {
    generateBackground(data) {
      this.pointListStyle = new Array(data.length).fill(0).map(() => ({ transform: `rotate(0deg)`, color: '' }))
      const sum = data.reduce((prev, curr) => prev + curr.value, 0)
      const surplus = 360 - this.gapDeg * data.length
      let backgroundStr = `conic-gradient(${this.gapBackgroundColor} 0, `
      let currentDeg = 0

      data.forEach((item, index) => {
        const step = (item.value / sum) * surplus
        const endDeg = currentDeg + step

        const gradientColor = item.color || this.defColorList[index]
        if (this.gradientType === 'gradient') {
          const cutDeg = currentDeg + step / 2
          backgroundStr += `${gradientColor} ${cutDeg.toFixed(2)}deg, ${this.gapBackgroundColor} ${(endDeg + 0.1).toFixed(2)}deg, ${this.gapBackgroundColor} ${(
            endDeg + this.gapDeg
          ).toFixed(2)}deg, `
        } else {
          backgroundStr += `${gradientColor} ${endDeg.toFixed(2)}deg, ${this.gapBackgroundColor} ${(endDeg + 0.1).toFixed(2)}deg, ${this.gapBackgroundColor} ${(
            endDeg + this.gapDeg
          ).toFixed(2)}deg, `
        }
        this.pointListStyle[index] = {
          transform: `rotate(${endDeg.toFixed(2)}deg)`,
          color: gradientColor,
        }
        currentDeg = currentDeg + step + this.gapDeg
      })
      backgroundStr += `${this.gapBackgroundColor} 0)`
      return backgroundStr
    },
    addUnit(value, unit = 'vw') {
      if (typeof value === 'number' || !Number.isNaN(Number(value))) {
        return `${(this.ringSize / 1920) * 100}${unit}`
      }
      return value
    },
  },
}
</script>

<style lang="scss" scoped>
.n-ring {
  position: relative;
  .infiniteAnimation {
    animation: round 2s linear infinite;
  }

  .animation {
    animation: round 2s linear;
  }

  &__gradient {
    width: 100%;
    height: 100%;
    border-radius: 9999px;
  }
  &__point {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    z-index: 999;
    div {
      position: absolute;
      background: #7ab4fa;
      left: 50%;
      transform: translateX(-50%);
      border-radius: 99999px;
    }
  }
  @keyframes round {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  &__gap {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 99999px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    &__wrapper {
      position: relative;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
